/****************************************************
 * Module Name:  memostatusProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class MemostatusProxy {
  static GetAllMemostatus = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/memostatus",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMemostatusMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/memostatus/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleMemostatus = (MemostatusId, callback) => {
    let params = {
      id: MemostatusId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/memostatus",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckMemostatusAvailable = (memostatus, callback) => {
    let params = {
      memostatus: memostatus,
    };

    restAPICall(
      Constants.MANAGER_URL + "/memostatus/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddMemostatus = (memostatus, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/memostatus",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(memostatus),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateMemostatus = (memostatus, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/memostatus",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(memostatus),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
